import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  id: "accuracyBarChart",
  style: {
    "width": "700px",
    "height": "400px"
  }
}, null, -1);
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "levelBarChart",
  style: {
    "width": "700px",
    "height": "400px"
  }
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _hoisted_2], 64);
}